<template>
  <div class="loginmodal">
    <div class="joinwrap">
      <img class="jointopimg" src="@/assets/img/sign_end_icon.png" />
      <h3 class="join-title">{{ $t('front.signup.signUpA')}}<br />{{ $t('front.signup.signUpB')}} <span class="gn">{{ $t('front.signup.signUpC')}}</span>{{ $t('front.signup.signUpD')}}</h3>
      <p class="jointtxt">{{ $t('front.signup.signUpE')}}<br />{{ $t('front.signup.signUpF')}}</p>
      <ul class="joine">
        <li><img src="@/assets/img/circle_lock.png" /><span>{{ $t('front.signup.signUpG')}}<br />{{ $t('front.signup.signUpH')}}<br />{{ $t('front.signup.signUpI')}}</span></li>
        <li><img src="@/assets/img/lock.png" /><span>{{ $t('front.signup.signUpJ')}}<br />{{ $t('front.signup.signUpK')}}<br />{{ $t('front.signup.signUpL')}}</span></li>
        <li><img src="@/assets/img/waste_basket.png" /><span>{{ $t('front.signup.signUpM')}}<br />{{ $t('front.signup.signUpN')}}<br />{{ $t('front.signup.signUpO')}}</span></li>
      </ul>
      <a class="loginnbtn on" @click="$emit('close')">{{ $t('front.gnb.login')}}</a>
    </div>
  </div>
</template>

<script>

export default {
  name: 'JoinComplete'
}
</script>

<style scoped>

</style>

<style scoped src="@/styles/header.css"></style>
<style scoped src="@/styles/common.css"></style>
<style scoped src="@/styles/subcommon.css"></style>
